var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.isEdit ? "编辑活动" : "新增活动",
            top: "50px",
            width: "1000px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "140px",
                size: "small",
              },
            },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("基础信息"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "营销方:", prop: "marketer" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.marketer,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "marketer", $$v)
                                },
                                expression: "formData.marketer",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("平台"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("商家"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动状态:", prop: "status" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "status", $$v)
                                },
                                expression: "formData.status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("长期有效"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("指定时间段有效"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("禁用"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称:", prop: "activityName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入活动名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动编码:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.formData.activityCode || "自动生成",
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.status === 2
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动开始时间:",
                                prop: "startTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择开始时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "default-time": "00:00:00",
                                },
                                model: {
                                  value: _vm.formData.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "startTime", $$v)
                                  },
                                  expression: "formData.startTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动结束时间:",
                                prop: "endTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择结束时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "default-time": "23:59:59",
                                },
                                model: {
                                  value: _vm.formData.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "endTime", $$v)
                                  },
                                  expression: "formData.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "适用小程序:", prop: "customerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                placeholder: "请选择小程序",
                                loading: _vm.customerLoading,
                                clearable: "",
                              },
                              on: {
                                clear: function ($event) {
                                  _vm.formData.customerId = null
                                },
                              },
                              model: {
                                value: _vm.formData.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "customerId", $$v)
                                },
                                expression: "formData.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.customerId,
                                attrs: {
                                  label: item.appName,
                                  value: item.customerId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动描述:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 1,
                              placeholder: "请输入活动描述",
                              maxlength: "1000",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.formData.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "description", $$v)
                              },
                              expression: "formData.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("活动优惠规则"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动场景:" } },
                        [
                          _c("el-input", {
                            attrs: { value: "线下门店核销", disabled: "" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销供应商:", prop: "supplierId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                placeholder: "请选择核销供应商",
                                loading: _vm.supplierLoading,
                                clearable: "",
                              },
                              on: {
                                clear: _vm.handleSupplierClear,
                                change: _vm.handleSupplierChange,
                              },
                              model: {
                                value: _vm.formData.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "supplierId", $$v)
                                },
                                expression: "formData.supplierId",
                              },
                            },
                            _vm._l(_vm.supplierList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.supplierName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "适用门店:" } }, [
                        _c(
                          "div",
                          { staticClass: "store-selector-box" },
                          [
                            _c("div", { staticClass: "store-selector-tip" }, [
                              _vm._v(
                                "说明：默认全部参与，即供应商下所有门店都参与立减活动；如需限制部分门店参与，请勾选具体门店。"
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-radio-group",
                              {
                                on: {
                                  change: _vm.handleStoreParticipateTypeChange,
                                },
                                model: {
                                  value: _vm.storeParticipateType,
                                  callback: function ($$v) {
                                    _vm.storeParticipateType = $$v
                                  },
                                  expression: "storeParticipateType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("全部参与"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("部分参与"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.storeParticipateType === 2
                              ? _c(
                                  "div",
                                  { staticClass: "store-select-wrapper" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          multiple: "",
                                          filterable: "",
                                          placeholder: "请选择参与门店",
                                          loading: _vm.storeLoading,
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.formData.storeIds,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "storeIds",
                                              $$v
                                            )
                                          },
                                          expression: "formData.storeIds",
                                        },
                                      },
                                      _vm._l(_vm.storeList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.storeList.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "store-selected-info",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t已加载 " +
                                                _vm._s(_vm.storeList.length) +
                                                " 家门店\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: _vm.selectAllStores,
                                                },
                                              },
                                              [_vm._v("全选")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: _vm.clearAllStores,
                                                },
                                              },
                                              [_vm._v("清空")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动类型:", prop: "activityType" } },
                        [
                          _c("el-input", {
                            attrs: { value: "折扣", disabled: "" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动门槛:", prop: "threshold" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              max: 999999999,
                              precision: 2,
                              placeholder: "0代表无门槛",
                            },
                            model: {
                              value: _vm.formData.threshold,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "threshold", $$v)
                              },
                              expression: "formData.threshold",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "核销商家小程序是否展示优惠:",
                            prop: "showDiscountToMiniapp",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.showDiscountToMiniapp,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "showDiscountToMiniapp",
                                    $$v
                                  )
                                },
                                expression: "formData.showDiscountToMiniapp",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("展示"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("不展示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 30 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "门槛计算方式:",
                            prop: "thresholdCalcType",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.thresholdCalcType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "thresholdCalcType",
                                    $$v
                                  )
                                },
                                expression: "formData.thresholdCalcType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("按订单金额金额进行计算"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("按照实际支付进行计算"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "优惠计算方式:",
                            prop: "discountCalcType",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.discountCalcType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "discountCalcType",
                                    $$v
                                  )
                                },
                                expression: "formData.discountCalcType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("按实际支付金额进行计算"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠信息:" } },
                        [
                          _c("div", { staticClass: "discount-tip-box" }, [
                            _c("div", { staticClass: "form-tip" }, [
                              _c("strong", [_vm._v("说明：")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-tip" }, [
                              _vm._v(
                                "1、满减门槛为0代表无门槛；折扣只能设置大于0小于10并且最多保留两位有效小数。"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-tip" }, [
                              _vm._v(
                                "2、判断门槛是否达到门槛，是下面配置的福卡+微信总使用金额是否达到门槛，若未配置福卡或者微信对于的使用金额则不算入使用门槛。"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.discountList,
                                border: "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "60",
                                  align: "center",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "fuCardId",
                                  label: "支付方式",
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      var $index = ref.$index
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              filterable: "",
                                              placeholder: "请选择支付方式",
                                              loading: _vm.paymentLoading,
                                              clearable: "",
                                            },
                                            on: {
                                              change: function (val) {
                                                return _vm.handlePaymentChange(
                                                  val,
                                                  $index
                                                )
                                              },
                                            },
                                            model: {
                                              value: row.fuCardId,
                                              callback: function ($$v) {
                                                _vm.$set(row, "fuCardId", $$v)
                                              },
                                              expression: "row.fuCardId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.getAvailablePayments($index),
                                            function (pay) {
                                              return _c("el-option", {
                                                key: pay.id,
                                                attrs: {
                                                  label: pay.name,
                                                  value: pay.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "discountValue",
                                  label: "优惠力度（折扣值）",
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            min: 0,
                                            max: 9.99,
                                            precision: 2,
                                            step: 0.1,
                                            placeholder: "请输入折扣值",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prefix",
                                                fn: function () {
                                                  return [_vm._v("打")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "suffix",
                                                fn: function () {
                                                  return [_vm._v("折")]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: row.discountValue,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row,
                                                "discountValue",
                                                $$v
                                              )
                                            },
                                            expression: "row.discountValue",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "100",
                                  align: "center",
                                  fixed: "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var $index = ref.$index
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                _vm.formData.discountList
                                                  .length <= 1,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemoveDiscount(
                                                  $index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "8px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    plain: "",
                                    size: "small",
                                    icon: "el-icon-plus",
                                    disabled:
                                      _vm.formData.discountList.length >= 10,
                                  },
                                  on: { click: _vm.handleAddDiscount },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t新增优惠信息\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("优惠券叠加规则"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠券叠加:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "coupon-select",
                              staticStyle: {
                                width: "330px",
                                "max-width": "100%",
                              },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                remote: "",
                                placeholder: "请搜索可叠加的优惠券",
                                "remote-method": _vm.searchCouponList,
                                loading: _vm.couponLoading,
                                clearable: "",
                              },
                              model: {
                                value: _vm.formData.couponIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "couponIds", $$v)
                                },
                                expression: "formData.couponIds",
                              },
                            },
                            _vm._l(_vm.couponList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.formData.couponIds && _vm.formData.couponIds.length
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "叠加计算规则:",
                                prop: "stackCalcType",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.stackCalcType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "stackCalcType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.stackCalcType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("以优惠券抵扣后订单金额计算门槛"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("以优惠券抵扣前订单金额计算门槛"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("订单退款优惠计算规则"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "部分退款处理方案:" } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.formData.refundType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "refundType", $$v)
                                },
                                expression: "formData.refundType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "仅按比例分摊，不重新校验门槛",
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("备注"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder: "请输入备注",
                              maxlength: "255",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.formData.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }